import { hasPermission, Permissions } from 'Permissions'
import { usePermissions } from 'react-admin'
import { DropdownButton } from 'shared/components/Dropdown/DropdownButton'
import { truthy } from 'shared/helpers/typeHelper'
import { useOnboardingChecklist } from 'shared/hooks/query/useOnboardingChecklist'
import { OnboardingChecklist } from 'shared/models/onboarding'
import { User } from 'shared/models/user'
import { styled } from 'styled-components'

import { TaskStatus } from '../../helpers/constants'
import { UserOnboardingCheckOrder } from './UserOnboardingCheckOrder'

interface UserOnboardingOrderDropdownProps {
  user: User
  driverApplication: OnboardingChecklist
  employmentHistory: OnboardingChecklist
}

export function UserOnboardingOrderDropdown({
  user,
  employmentHistory,
  driverApplication,
}: UserOnboardingOrderDropdownProps) {
  const { refetch } = useOnboardingChecklist(user.id, { enabled: false })
  const { permissions } = usePermissions()

  const options = [
    user.driver.checkrCandidateUrl
      ? {
          label: 'View reports on Checkr',
          onClick: () => window.open(user.driver.checkrCandidateUrl, '_blank'),
        }
      : undefined,
    {
      label: 'package2',
      renderer: () => (
        <UserOnboardingCheckOrder
          userId={user.id}
          isInitial={false}
          isCheckr={Boolean(user.permissions?.checkrPackage2Onboarding?.enabled)}
          onSuccess={refetch}
          disabled={!(permissions && hasPermission(permissions, Permissions.OrderBgcPackageTwo))}
        />
      ),
    },
    {
      label: 'package1',
      renderer: () => (
        <UserOnboardingCheckOrder
          userId={user.id}
          isInitial={true}
          isCheckr={Boolean(user.permissions?.checkrPackage1Onboarding?.enabled)}
          initialCheckShouldAlreadyExists={[TaskStatus.IN_PROGRESS, TaskStatus.COMPLETED].includes(
            driverApplication.status
          )}
          disabled={[TaskStatus.NOT_STARTED, TaskStatus.ERROR, TaskStatus.PREREQUISITES_NOT_MET].includes(
            employmentHistory.status
          )}
          onSuccess={refetch}
        />
      ),
    },
  ].filter(truthy)

  return (
    <Wrap>
      <DropdownButton
        options={options}
        label="Order background check"
        buttonProps={{ variant: 'text' }}
        width={250}
        maxHeight={250}
        align="left"
        fontSize="12px"
      />
    </Wrap>
  )
}

const Wrap = styled.div`
  padding-right: 10px;
  width: 200px;
  display: flex;
  justify-content: start;
`
